"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Integration_module_css_1 = __importDefault(require("../Integration.module.css"));
var react_i18next_1 = require("react-i18next");
var ImagePrviewModal = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var ModalHeader = function () {
        return (react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
            t("Preview"),
            ":"));
    };
    var ModalBody = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between", gap: "10px" } },
                react_1.default.createElement("div", { className: Integration_module_css_1.default["ns-page-card"], style: { width: "100%", textAlign: "center" } },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("img", { src: props.resource.file, style: { maxWidth: "100%" } }))))));
    };
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, onClose: props.onClose, header: react_1.default.createElement(ModalHeader, null), body: react_1.default.createElement(ModalBody, null), dialogClassName: Integration_module_css_1.default["integration-script-debug-modal"] }));
};
exports.default = ImagePrviewModal;
